import {
  NotificationPreferences,
  UpdateNotificationPreferencesDto,
} from '../core/notification-preferences';
import { HttpClient } from './http';

export interface NotificationPreferencesService {
  getNotificationPreferences: () => Promise<NotificationPreferences>;
  updateNotificationPreferences: (
    dto: UpdateNotificationPreferencesDto,
  ) => Promise<NotificationPreferences>;
}

export function createNotificationPreferencesService(
  httpClient: HttpClient,
  baseUrl: string,
): NotificationPreferencesService {
  return {
    getNotificationPreferences: () => {
      return httpClient<NotificationPreferences>(
        `${baseUrl}/notification-preferences`,
        'get',
      );
    },

    updateNotificationPreferences: (dto: UpdateNotificationPreferencesDto) => {
      return httpClient<NotificationPreferences>(
        `${baseUrl}/notification-preferences`,
        'patch',
        { body: dto },
      );
    },
  };
}
